import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import svg from "../../../Assets/svg";

const JoinChallenge = () => {
  const { id: challengeId } = useParams();
  const [platform, setPlatform] = useState("other");
  const [redirected, setRedirected] = useState(false);

  const storeLink =
    platform === "android"
      ? "https://play.google.com/store/apps/details?id=com.kriyauniverse"
      : platform === "ios"
      ? "https://apps.apple.com/il/app/kriyaverse/id6496065508"
      : "https://kriyaverse.com/";

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      setPlatform("android");
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      setPlatform("ios");
    } else {
      setPlatform("other");
    }

    const timeout = setTimeout(() => {
      window.location.href = storeLink;
      setRedirected(true);
    }, 2500);

    return () => clearTimeout(timeout);
  }, [storeLink]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center px-3">
      <div className="mb-sm-5 mb-4">
        <span className="login-logo">{svg?.logo}</span>
      </div>

      <h2>Redirecting...</h2>
      <p className="mb-4">
        Please wait. If nothing happens, use the button below to download the
        app manually.
      </p>

      {redirected && (
        <a
          href={storeLink}
          className="btn btn-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Store
        </a>
      )}
    </div>
  );
};

export default JoinChallenge;
